import { SurveyPreInterviewTemplateForm } from './SurveyPreInterviewTemplateForm';
import { SurveyPreInterviewTemplateFormLoader } from './SurveyPreInterviewTemplateForm.loader';

export const SurveyPreInterviewTemplate = (): JSX.Element => {
   return (
      <SurveyPreInterviewTemplateFormLoader>
         {({ surveyTemplate, refetchSurveyTemplate }) => (
            <SurveyPreInterviewTemplateForm
               refetchSurveyTemplate={refetchSurveyTemplate}
               surveyTemplate={surveyTemplate}
            />
         )}
      </SurveyPreInterviewTemplateFormLoader>
   );
};
